<div class="header">
  <div>
    <h2>{{ 'pages.analytics.conversations.title' | translate }}</h2>
    <p class="subtitle">
      {{ 'pages.analytics.conversations.subtitle' | translate }}
    </p>
  </div>
</div>

<nb-card alAnchor="analytics.conversations">
  <nb-card-header>
    <div class="cv-toolbar">
      <div class="cv-toolbar__group" alAnchor="analytics.conversation-filters">
        <button
          nbButton
          size="tiny"
          *ngFor="let d of dayPresets"
          [status]="days === d ? 'primary' : 'basic'"
          (click)="setDays(d)"
        >
          {{ 'pages.analytics.conversations.filters.days' | translate : { days: d } }}
        </button>
      </div>

      <div class="cv-toolbar__group">
        <nb-select
          size="small"
          alAnchor="analytics.rating-filter"
          [selected]="rating"
          (selectedChange)="setRating($event)"
        >
          <nb-option value="any">{{ 'pages.analytics.conversations.rating.any' | translate }}</nb-option>
          <nb-option value="down">{{ 'pages.analytics.conversations.rating.down' | translate }}</nb-option>
          <nb-option value="down_with_text">{{ 'pages.analytics.conversations.rating.downWithText' | translate }}</nb-option>
          <nb-option value="up">{{ 'pages.analytics.conversations.rating.up' | translate }}</nb-option>
        </nb-select>

        <nb-select
          size="small"
          [selected]="botId || allValue"
          (selectedChange)="setBot($event)"
        >
          <nb-option [value]="allValue">{{ 'pages.analytics.conversations.filters.allAgents' | translate }}</nb-option>
          <nb-option *ngFor="let bot of bots" [value]="bot.id">
            {{ bot.name || bot.id }} ({{ bot.count }})
          </nb-option>
        </nb-select>

        <nb-select
          size="small"
          [selected]="courseId || allValue"
          (selectedChange)="setCourse($event)"
        >
          <nb-option [value]="allValue">{{ 'pages.analytics.conversations.filters.allCourses' | translate }}</nb-option>
          <nb-option *ngFor="let course of courses" [value]="course.id">
            {{ course.name || course.id }} ({{ course.count }})
          </nb-option>
        </nb-select>

        <nb-select
          size="small"
          [selected]="sort"
          (selectedChange)="setSort($event)"
        >
          <nb-option value="recent">{{ 'pages.analytics.conversations.sort.recent' | translate }}</nb-option>
          <nb-option value="thumbs_down">{{ 'pages.analytics.conversations.sort.thumbsDown' | translate }}</nb-option>
        </nb-select>
      </div>

      <div class="cv-toolbar__group cv-toolbar__group--grow">
        <!-- Volltextsuche über Frage, Antwort und Begründung aller Turns im
             Zeitraum. Trifft die Sitzung, nicht die einzelne Zeile. -->
        <input
          nbInput
          fieldSize="small"
          type="search"
          class="cv-search"
          [attr.placeholder]="'pages.analytics.conversations.filters.searchPlaceholder' | translate"
          [value]="search"
          (input)="onSearchInput($any($event.target).value)"
        />
        <span class="cv-total">
          {{ 'pages.analytics.conversations.total' | translate : { total: total } }}
        </span>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <p class="cv-empty" *ngIf="loading">
      {{ 'pages.analytics.conversations.loading' | translate }}
    </p>

    <p class="cv-empty" *ngIf="!loading && !rows.length">
      {{ 'pages.analytics.conversations.empty' | translate }}
    </p>

    <div class="cv-row" *ngFor="let row of rows; trackBy: trackRow">
      <header class="cv-row__head" alAnchor="analytics.conversation-row" (click)="toggle(row)">
        <nb-icon
          class="cv-row__chev"
          [icon]="openSessionId === row.session_id ? 'chevron-down-outline' : 'chevron-right-outline'"
        ></nb-icon>
        <span class="cv-row__when">{{ row.last_seen | date : 'short' }}</span>
        <span class="cv-row__where" *ngIf="row.bot_name">{{ row.bot_name }}</span>
        <span class="cv-row__where muted" *ngIf="row.course_name">{{ row.course_name }}</span>

        <span class="cv-row__preview" *ngIf="row.feedback_text">„{{ row.feedback_text }}"</span>
        <span class="cv-row__preview muted" *ngIf="!row.feedback_text">{{ row.first_question }}</span>

        <span class="cv-badges">
          <span class="cv-badge" [nbTooltip]="'pages.analytics.conversations.badges.turns' | translate">
            {{ row.turns }} ×
          </span>
          <span
            class="cv-badge is-down"
            *ngIf="row.thumbs_down"
            [nbTooltip]="'pages.analytics.conversations.badges.thumbsDown' | translate"
          >
            <nb-icon icon="arrow-downward-outline"></nb-icon>{{ row.thumbs_down }}
          </span>
          <span
            class="cv-badge is-up"
            *ngIf="row.thumbs_up"
            [nbTooltip]="'pages.analytics.conversations.badges.thumbsUp' | translate"
          >
            <nb-icon icon="arrow-upward-outline"></nb-icon>{{ row.thumbs_up }}
          </span>
          <span
            class="cv-badge is-gap"
            *ngIf="row.ungrounded"
            [nbTooltip]="'pages.analytics.conversations.badges.ungrounded' | translate"
          >
            {{ row.ungrounded }}/{{ row.measured }}
          </span>
        </span>
      </header>

      <div class="cv-row__body" *ngIf="openSessionId === row.session_id">
        <p class="cv-empty" *ngIf="detailLoading">
          {{ 'pages.analytics.conversations.thread.loading' | translate }}
        </p>

        <p class="cv-empty" *ngIf="!detailLoading && detail && !detail.available">
          {{ 'pages.analytics.conversations.thread.unavailable' | translate }}
        </p>

        <p class="cv-note" *ngIf="!detailLoading && detail?.source === 'checkpointer'">
          {{ 'pages.analytics.conversations.thread.fromCheckpointer' | translate }}
        </p>

        <ul class="cv-thread" alAnchor="analytics.conversation-thread" *ngIf="!detailLoading && detail?.messages?.length">
          <li
            *ngFor="let m of detail!.messages"
            [ngClass]="['is-' + m.role, m.rating ? 'has-rating-' + m.rating : '']"
          >
            <span class="cv-thread__role">
              {{
                (m.role === 'user'
                  ? 'pages.analytics.conversations.thread.learner'
                  : 'pages.analytics.conversations.thread.agent'
                ) | translate
              }}
            </span>
            <span class="cv-thread__body">
              <span class="cv-thread__text">{{ m.text }}</span>
              <span class="cv-thread__marks">
                <span class="cv-mark is-down" *ngIf="m.rating === 'down'">
                  <nb-icon icon="arrow-downward-outline"></nb-icon>
                  {{ 'pages.analytics.conversations.thread.ratedDown' | translate }}
                </span>
                <span class="cv-mark is-up" *ngIf="m.rating === 'up'">
                  <nb-icon icon="arrow-upward-outline"></nb-icon>
                  {{ 'pages.analytics.conversations.thread.ratedUp' | translate }}
                </span>
                <span class="cv-mark is-gap" *ngIf="m.grounded === false">
                  {{ 'pages.analytics.conversations.thread.noSources' | translate }}
                </span>
              </span>
              <span class="cv-reason" alAnchor="analytics.feedback-reason" *ngIf="m.feedback_text">
                <span class="cv-reason__label">
                  {{ 'pages.analytics.conversations.thread.reason' | translate }}
                </span>
                „{{ m.feedback_text }}"
              </span>
              <!-- Curation entry: every answer with a turn event, not only
                   rated ones — nobody flags an answer that was merely thin. -->
              <span class="cv-learn" *ngIf="canLearnFrom(m)">
                <span class="cv-mark is-learned" *ngIf="m.learning_ids?.length">
                  <nb-icon icon="bulb-outline"></nb-icon>
                  {{ 'pages.learnings.draft.alreadyLearned' | translate: { count: m.learning_ids!.length } }}
                </span>
                <button nbButton ghost size="tiny" status="primary" type="button" alAnchor="analytics.learn-from" (click)="learnFrom(m)"
                  [nbTooltip]="'pages.learnings.tooltips.learnFrom' | translate">
                  <nb-icon icon="bulb-outline"></nb-icon>
                  {{ 'pages.learnings.draft.action' | translate }}
                </button>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="cv-pager" *ngIf="maxPage > 1">
      <button nbButton size="tiny" status="basic" [disabled]="page <= 1" (click)="setPage(page - 1)">
        {{ 'pages.analytics.conversations.pager.prev' | translate }}
      </button>
      <span class="muted">
        {{ 'pages.analytics.conversations.pager.position' | translate : { page: page, pages: maxPage } }}
      </span>
      <button nbButton size="tiny" status="basic" [disabled]="page >= maxPage" (click)="setPage(page + 1)">
        {{ 'pages.analytics.conversations.pager.next' | translate }}
      </button>
    </div>
  </nb-card-body>
</nb-card>
